<template>
  <div v-if="unpaidTotal > 0" class="unpaid-banner">
    <div class="unpaid-main">
      <i class="mdi mdi-alert-octagon"></i>
      <strong>UNPAID — KES {{ formatMoney(unpaidTotal) }} outstanding</strong>
      <span class="unpaid-detail">
        across {{ invoices.length }} invoice{{ invoices.length === 1 ? '' : 's' }}
        ({{ invoiceNumbers }}). Confirm payment or an approved waiver at Billing before service.
        Emergencies may still be served.
      </span>
    </div>
    <button class="unpaid-refresh" @click="load" title="Re-check payment status">
      <i class="mdi mdi-refresh"></i> Re-check
    </button>
  </div>
</template>

<script>
import { executeJson, hms } from "@/api";

export default {
  name: "UnpaidBanner",
  props: {
    patientId: { type: [Number, String], default: null }
  },
  data() {
    return {
      unpaidTotal: 0,
      invoices: []
    };
  },
  computed: {
    invoiceNumbers() {
      return this.invoices.slice(0, 3).map(function(i) { return i.invoice_number; }).join(", ")
        + (this.invoices.length > 3 ? ", …" : "");
    }
  },
  watch: {
    patientId: { immediate: true, handler: "load" }
  },
  methods: {
    formatMoney(v) {
      return Number(v || 0).toLocaleString("en-KE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    async load() {
      this.unpaidTotal = 0;
      this.invoices = [];
      if (!this.patientId) return;
      try {
        const r = await executeJson({ function: "getPatientBillingStatus", patient_id: this.patientId }, hms);
        if (r.data && r.data.success && r.data.data) {
          this.unpaidTotal = Number(r.data.data.unpaid_total || 0);
          this.invoices = r.data.data.unpaid_invoices || [];
        }
      } catch (e) {
        console.error(e);
      }
    }
  }
};
</script>

<style scoped>
.unpaid-banner {
  display: flex; align-items: center; justify-content: space-between; gap: 12px;
  background: #fff7ed; border: 1px solid #fdba74; border-left: 5px solid #ea580c;
  color: #9a3412; border-radius: 8px; padding: 10px 14px; margin-bottom: 12px; font-size: 13px;
}
.unpaid-main { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.unpaid-main .mdi-alert-octagon { font-size: 20px; color: #ea580c; }
.unpaid-detail { color: #7c2d12; }
.unpaid-refresh {
  background: #fff; border: 1px solid #fdba74; color: #9a3412; border-radius: 6px;
  padding: 4px 10px; font-size: 12px; cursor: pointer; white-space: nowrap;
}
.unpaid-refresh:hover { background: #ffedd5; }
</style>
